import request from '@/utils/request'
import axios from 'axios'

export async function submitAbstract(formData, progressCallback = null) {
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  if (progressCallback) {
    config.onUploadProgress = (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      progressCallback(percentCompleted)
    }
  }
  const response = await axios.post(process.env.VUE_APP_API_URL + '/abstract-submission', formData, config)
  return response.data
}

export async function uploadAbstractFile(file, progressCallback = null) {
  const formData = new FormData()
  formData.append('file', file)
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  if (progressCallback) {
    config.onUploadProgress = (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      progressCallback(percentCompleted)
    }
  }
  const response = await axios.post(process.env.VUE_APP_API_URL + '/abstract-upload', formData, config)
  return response.data
}

export async function uploadPosterFile(file, progressCallback = null) {
  const formData = new FormData()
  formData.append('file', file)
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  if (progressCallback) {
    config.onUploadProgress = (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      progressCallback(percentCompleted)
    }
  }
  const response = await axios.post(process.env.VUE_APP_API_URL + '/poster-upload', formData, config)
  return response.data
}

export function getSubmissions(params) {
  return request({
    url: '/abstract-submissions',
    method: 'get',
    params
  })
}

export function updateSubmission(id, data) {
  return request({
    url: `/abstract-submissions/${id}`,
    method: 'put',
    data
  })
}

export function deleteSubmission(id) {
  return request({
    url: `/abstract-submissions/${id}`,
    method: 'delete'
  })
}